import React from 'react';
import { useState } from 'react';
import { Modal, Input, Typography } from 'antd';
import { useSelector } from 'react-redux';
const { Text } = Typography;

const TitleModal = ({
  showNameChangeModel,
  basicReportData,
  onOkforTitleModal,
  handleChangeName,
  purpose,
}) => {
  const cardTemplate = useSelector((state) => state.report.card_template_id);
  const [data, setData] = useState({
    name: basicReportData.name || cardTemplate.name || '',
    purpose: purpose,
  });

  return (
    <Modal
      title={'Rename Report'}
      visible={showNameChangeModel}
      onOk={() => onOkforTitleModal(data)}
      okText='Save'
      onCancel={() => {
        handleChangeName(false);
      }}
    >
      <Text>Title</Text>
      <Input
        id='reportNameField'
        style={{ marginTop: 16, marginBottom: 16 }}
        placeholder='Enter name here'
        value={data && data.name}
        onChange={(e) => {
          setData({ ...data, name: e.target.value });
        }}
      ></Input>
      <Text>Purpose</Text>
      <Input
        id='reportNameField'
        style={{ marginTop: 16 }}
        placeholder='Enter Purpose'
        value={data.purpose}
        onChange={(e) => {
          setData({ ...data, purpose: e.target.value });
        }}
      ></Input>
    </Modal>
  );
};

export default TitleModal;
